import React from "react";
import { AddressPopupPropTypes } from "../types";
import PropTypes from "prop-types";
import { DELIVERY_TYPES } from "../layout";

const DeliveryTypeSwitcher = ({
    labels,
    bicycleIcon,
    shopIcon,
    deliveryType,
    setDeliveryType,
}) => {
    const switchStyles = (deliveryTypeForOrder) =>
        `address-popup__switch ${
            deliveryTypeForOrder === deliveryType ? "active" : ""
        }`;

    return (
        <div className="address-popup__switcher">
            <button
                className={switchStyles(DELIVERY_TYPES.DELIVERY)}
                onClick={() => setDeliveryType(DELIVERY_TYPES.DELIVERY)}
            >
                <img src={bicycleIcon} alt={DELIVERY_TYPES.DELIVERY} />
                {labels.delivery}
            </button>
            <button
                className={switchStyles(DELIVERY_TYPES.PICKUP)}
                onClick={() => setDeliveryType(DELIVERY_TYPES.PICKUP)}
            >
                <img src={shopIcon} alt={DELIVERY_TYPES.PICKUP} />
                {labels.pickup}
            </button>
        </div>
    );
};

DeliveryTypeSwitcher.propTypes = {
    labels: AddressPopupPropTypes.labels,
    bicycleIcon: PropTypes.string,
    shopIcon: PropTypes.string,
    deliveryType: PropTypes.string,
    setDeliveryType: PropTypes.func,
};
export default DeliveryTypeSwitcher;
